module.exports = __webpack_public_path__ + "static/index/img/baikal-706.2279d2cc.jpg";